var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM12 16.6C12.3314 16.6 12.6 16.3314 12.6 16V11.2C12.6 10.8686 12.3314 10.6 12 10.6C11.6686 10.6 11.4 10.8686 11.4 11.2V16C11.4 16.3314 11.6686 16.6 12 16.6ZM12 8C12.4418 8 12.8 8.35817 12.8 8.8C12.8 9.24183 12.4418 9.6 12 9.6C11.5582 9.6 11.2 9.24183 11.2 8.8C11.2 8.35817 11.5582 8 12 8Z",
    fill: "#8E092E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.feae21ba2fbada1e001e5b15df81fd6a.svg";
export { ForwardRef as ReactComponent };